import React from "react";

const VARIANT_CLASS = {
	default: "grader-badge--default",
	secondary: "grader-badge--secondary",
	destructive: "grader-badge--destructive",
	outline: "grader-badge--outline",
	success: "grader-badge--success",
	warning: "grader-badge--warning",
	info: "grader-badge--info",
};

export function Badge({ className = "", variant = "default", ...props }) {
	const variantClass = VARIANT_CLASS[variant] || VARIANT_CLASS.default;
	return (
		<span
			className={`grader-badge ${variantClass} ${className}`.trim()}
			{...props}
		/>
	);
}
